<template>
  <div class="product-suggestion-item">
    <div class="d-flex align-items-center justify-content-between">
      <div class="flex-grow-1">
        <div class="product-name">{{ product.name }}</div>
        <div class="product-details">
          <span class="product-price text-primary me-2">
            ({{ convertPrice(product.sellingPrice) }})
          </span>
          <span :class="stockClass" class="stock-info">
            (Tồn CTB: {{ product.quantityInStock || 0 }})
          </span>
          <span class="product-code text-muted me-2">{{ product.code }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertPrice } from '@/utils/common';

export default {
  name: 'ProductSuggestionItem',

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    stockClass() {
      const stock = this.product.quantityInStock || 0;

      return {
        'text-success': stock > 10,
        'text-warning': stock > 0 && stock <= 10,
        'text-danger': stock <= 0,
      };
    },
  },

  methods: {
    convertPrice,
  },
};
</script>

<style scoped>
.product-suggestion-item {
  padding: 4px 0;
}

.product-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 2px;
}

.product-details {
  font-size: 1rem;
  display: flex;
  align-items: center;
  column-gap: 6px;
}

.product-code {
  font-family: monospace;
}

.stock-info {
  font-weight: 500;
}
</style>
